import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoveDown, MoveUp } from 'lucide-react';

interface ImageSortDropdownProps {
    sortBy: 'date' | 'name';
    setSortBy: (sortBy: 'date' | 'name') => void;
    isDescending: boolean;
    setIsDescending: (desc: boolean) => void;
}

export const ImageSortDropdown: React.FC<ImageSortDropdownProps> = props => {
    const { sortBy, setSortBy, isDescending, setIsDescending } = props;
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    className="w-min"
                    variant="outline"
                >
                    {sortBy === 'date' ? 'Date Modified' : 'Name'}
                    {isDescending ? <MoveDown className="ml-2 w-4 h-4" /> : <MoveUp className="ml-2 w-4 h-4" />}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuLabel>Sort By</DropdownMenuLabel>
                <DropdownMenuGroup>
                    <DropdownMenuCheckboxItem
                        onClick={() => {
                            setSortBy('date');
                        }}
                        onSelect={e => e.preventDefault()}
                        checked={sortBy === 'date'}
                    >
                        Date Modified
                    </DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem
                        onClick={() => {
                            setSortBy('name');
                        }}
                        onSelect={e => e.preventDefault()}
                        checked={sortBy === 'name'}
                    >
                        Name
                    </DropdownMenuCheckboxItem>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuLabel>Sort Direction</DropdownMenuLabel>
                <DropdownMenuGroup>
                    <DropdownMenuCheckboxItem
                        onClick={() => {
                            setIsDescending(true);
                        }}
                        onSelect={e => e.preventDefault()}
                        checked={isDescending}
                    >
                        {sortBy === 'date' ? 'New to Old' : 'Z to A'}
                    </DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem
                        onClick={() => {
                            setIsDescending(false);
                        }}
                        onSelect={e => e.preventDefault()}
                        checked={!isDescending}
                    >
                        {sortBy === 'date' ? 'Old to New' : 'A to Z'}
                    </DropdownMenuCheckboxItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
